import { render, staticRenderFns } from "./WeChat_application.vue?vue&type=template&id=4a99ee83&scoped=true&"
import script from "./WeChat_application.vue?vue&type=script&lang=js&"
export * from "./WeChat_application.vue?vue&type=script&lang=js&"
import style0 from "./WeChat_application.vue?vue&type=style&index=0&id=4a99ee83&prod&lang=less&"
import style1 from "./WeChat_application.vue?vue&type=style&index=1&id=4a99ee83&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a99ee83",
  null
  
)

export default component.exports